import sortable from 'html5sortable/dist/html5sortable.es'
import autoComplete from '@tarekraafat/autocomplete.js/src/models/autoComplete'
import axios from './setup/axios'

const RecipeMaterials = {
  materials: [],

  container: null,

  init: function(container) {
    const $this = this
    $this.container = $(container)

    if ($this.container.length > 0) {
      $this.container.children().each(function() {
        $this.materials.push(
          parseInt(
            $(this)
              .find('.id')
              .val()
          )
        )
      })
    }
    let [sortableElement] = sortable($this.container, {
      forcePlaceholderSize: true,
      helper: 'clone',
      items: '.material-line',
    })
    sortableElement.addEventListener('sortupdate', () => {
      $this.updatePositions()
    })
  },

  removeMaterial: function(id) {
    const $this = this
    const index = $this.materials.indexOf(parseInt(id))
    if (index > -1) {
      $this.materials.splice(index, 1)
      $(`#material-line-${id}`).remove()
    }
    $this.updatePositions()
  },

  addMaterial: function(elm, suggestion, isPastryCategory) {
    const $this = this

    const {
      value: {data},
    } = suggestion
    console.log(data)

    if ($this.materials.indexOf(data.id) === -1) {
      $.ajax({
        // eslint-disable-next-line no-undef
        url: materialLineRoute,
        data: {
          isPastryCategory: isPastryCategory ? 1:0,
          material: data,
          increment: $this.container.children().length,
        },
      }).done(function(html) {
        html = $(html)
        $this.materials.push(parseInt(data.id))
        $this.container.append(html)

        $(`#material-line-${data.id} .percent-qty`).focus()
        $this.updatePositions()
      })
    }
  },

  updatePositions: function() {
    const $this = this
    let position = 1
    $this.container.children('.material-line').each(function(index, element) {
      const materialId = $(element).data('material-id')
      $(`#position${materialId}`).val(position)
      position++
    })
  },
}

const materialAutocompleteCallback = function(elm, suggestion) {
  if (document.categoryIsPastry && suggestion.value.data.is_primary){
    alert(document.primaryRawForPastryAlert);
  }
  else{
    RecipeMaterials.addMaterial(elm, suggestion, document.categoryIsPastry)
  }
}
window.materialAutocompleteCallback = materialAutocompleteCallback

const materialDeleteCallback = function(id) {
  RecipeMaterials.removeMaterial(id)
}
window.materialDeleteCallback = materialDeleteCallback

document.addEventListener('DOMContentLoaded', () => {
  const recipeMaterials = document.querySelector('#recipe-materials')
  if (recipeMaterials === null) {
    return
  }

  RecipeMaterials.init(recipeMaterials)

  const autocompleteElements = document.querySelectorAll('.autocomplete')
  Array.from(autocompleteElements).forEach(element => {
    new autoComplete({
      selector: () => element,
      data: {
        src: async () => {
          const query = element.value
          const {
            data: {suggestions},
          } = await axios.get(element.dataset.url, {
            params: {
              query,
            },
          })

          return suggestions
        },
        key: ['value'],
        cache: false,
      },
      resultsList: {
        render: true,
        container: source => {
          source.setAttribute('class', 'autocomplete-suggestions')
        },
        destination: element,
        position: 'afterend',
        element: 'div',
      },
      resultItem: {
        content: (data, source) => {
          source.innerHTML = data.match
          source.setAttribute('class', 'autocomplete-suggestion')
        },
        element: 'div',
      },
      noResults: () => {
        const result = document.createElement('div')
        result.setAttribute('class', 'no_result')
        result.setAttribute('tabindex', '1')
        result.innerHTML = 'No Results'
        document.querySelector('.autocomplete-suggestions').appendChild(result)
      },
      onSelection: ({selection}) => {
        const callback = window[element.dataset.callback]
        if (typeof callback === 'function') {
          callback(element, selection)
        }
        element.value = ''
      },
    })
  })
})
